<template>
    <academic>
        <card-header :title="'Course Year: '+courseyear.title+' - '+courseyear.course.title" />
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table :fields="fields" :items="courseyearbatches" :action="{'text':'add course batch','url':route('academic.courseyear.batch.create',courseyear.id)}"  :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Course Year')" :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Course Year')">
                <template #status="data">
                    {{data.item.status?'Active':'Inactive'}}
                </template>
                <template #action="data">
                    <button-link v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Edit Course Year')" :href="route('academic.courseyear.batch.edit',[courseyear.id,data.item.id])" >Edit</button-link>
                </template>
            </breeze-table>
        </div>
    </academic>
</template>

<script>
    import Academic from '@/Pages/Academic/Academic'
    import BreezeTable from '@/Components/Table'
    import ButtonLink from '@/Components/ButtonLink'
    import CardHeader from '@/Components/CardHeader'

    export default {
        components: {
            Academic,
            BreezeTable,
            ButtonLink,
            CardHeader
        },
        props:['courseyearbatches','courseyear'],
        data(){
            return{
                fields:[{'key':'title','label':'Title'},{'key':'status','label':'Status'},{'key':'action','label':'Action'}]
            }
        }
    }
</script>
